// extracted by mini-css-extract-plugin
module.exports = {"blue":"PhoneLink-module__blue___1Yuhm","size":"PhoneLink-module__size___n-0xj"};